'use client';

import { c as _c } from "react/compiler-runtime";
import { fetchASPRefreshUserInfo } from '@module/apis/client-side/member';
import type { MemberLoginResponse } from '@module/apis/client-side/member/type';
import SettingConfig from '@module/config/setting';
import { useMemberLoginInfoQuery } from '@module/queries/member/memberQueryHooks';
import { memberQueryKeys } from '@module/queries/member/memberQueryKeys';
import TimeConstants from '@module/utils/item';
import { useQueryClient } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../../queries/type';
import { aspCond } from '../conditions/condition';
import { syncLoginInfoQueryData } from './syncLoginInfoQueryData';
const useGetLoginInfoQuery = options => {
  const $ = _c(23);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      staleTime: TimeConstants.ONE_MINUTE,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: loginInfo,
    isLoading: isLoginInfoLoading,
    isFetching: isLoginInfoFetching,
    refetch,
    isFetched,
    isError
  } = useMemberLoginInfoQuery(t0, t1);
  let t2;
  if ($[3] !== queryClient || $[4] !== refetch) {
    t2 = SettingConfig.isFanza ? async () => {
      try {
        const result = await fetchASPRefreshUserInfo();
        syncLoginInfoQueryData(queryClient, result.loginInfo);
        return {
          data: queryClient.getQueryData(memberQueryKeys.fetchMemberLoginInfo().queryKey),
          isError: false
        };
      } catch {
        return {
          data: queryClient.getQueryData(memberQueryKeys.fetchMemberLoginInfo().queryKey),
          isError: true
        };
      }
    } : refetch;
    $[3] = queryClient;
    $[4] = refetch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const refetchLoginInfo = t2;
  const userInfo = loginInfo?.loginInfo?.userInfo;
  const isUserInfo = !!userInfo;
  const isLogin = !!userInfo?.isLogin;
  const isAdult = !!userInfo?.isAdult;
  const isAuthDone = userInfo?.authYN === "Y";
  const siteMode = loginInfo?.loginInfo?.siteMode;
  const coinHave = userInfo?.coinHave;
  const wasLive = !!userInfo?.liveFirstDateTime && userInfo.liveFirstDateTime !== "0000-00-00 00:00:00";
  let isPostAvailable = true;
  if (aspCond.if("new-asp")) {
    isPostAvailable = SettingConfig.newASPPreset?.aspInfo?.postYN === "Y" && userInfo?.purchaseUser === "Y";
  }
  const t3 = userInfo?.isLogin;
  let t4;
  if ($[6] !== coinHave || $[7] !== isAdult || $[8] !== isAuthDone || $[9] !== isError || $[10] !== isFetched || $[11] !== isLogin || $[12] !== isLoginInfoFetching || $[13] !== isLoginInfoLoading || $[14] !== isPostAvailable || $[15] !== isUserInfo || $[16] !== loginInfo || $[17] !== refetchLoginInfo || $[18] !== siteMode || $[19] !== t3 || $[20] !== userInfo || $[21] !== wasLive) {
    t4 = {
      rawLoginState: t3,
      loginInfo,
      isLogin,
      isAdult,
      isUserInfo,
      userInfo,
      isLoginInfoLoading,
      isLoginInfoFetching,
      isFetched,
      isAuthDone,
      refetchLoginInfo,
      siteMode,
      coinHave,
      wasLive,
      isError,
      isPostAvailable
    };
    $[6] = coinHave;
    $[7] = isAdult;
    $[8] = isAuthDone;
    $[9] = isError;
    $[10] = isFetched;
    $[11] = isLogin;
    $[12] = isLoginInfoFetching;
    $[13] = isLoginInfoLoading;
    $[14] = isPostAvailable;
    $[15] = isUserInfo;
    $[16] = loginInfo;
    $[17] = refetchLoginInfo;
    $[18] = siteMode;
    $[19] = t3;
    $[20] = userInfo;
    $[21] = wasLive;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
};
export default useGetLoginInfoQuery;